// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "a359d87401733939908f4455b6767abbf9b91fd7/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};